/**
 * The GST portal's NEFT/RTGS bank master (payment.gst.gov.in/master/banks/NEFT, read 1 October 2026):
 * the banks a NEFT/RTGS challan can name as the one the money comes from, by the four letters their
 * IFSCs start with (the challan's bank_cd). `name` is how EkApp shows it; `portalName`, the portal's.
 * Generated from the portal's list; keep the order (it's the portal's).
 */
export const NEFT_BANK_ROWS: readonly (readonly [code: string, name: string, portalName: string])[] = [
  ['ABHY', 'Abhyudaya Cooperative Bank Limited', 'ABHYUDAYA COOPERATIVE BANK LIMITED'],
  ['ADCB', 'Abu Dhabi Commercial Bank', 'ABU DHABI COMMERCIAL BANK'],
  ['ABPB', 'Aditya Birla Idea Payments Bank', 'ADITYA BIRLA IDEA PAYMENTS BANK'],
  ['AMCB', 'Ahmedabad Mercantile Cooperative Bank', 'AHMEDABAD MERCANTILE COOPERATIVE BANK'],
  ['AMDN', 'Ahmednagar Merchants Co-op. Bank Ltd.', 'AHMEDNAGAR MERCHANTS CO-OP. BANK LTD.'],
  ['AIRP', 'Airtel Payments Bank', 'AIRTEL PAYMENTS BANK LIMITED'],
  ['AANB', 'Akhand Anand Co-operative Bank Ltd', 'AKHAND ANAND CO-OPERATIVE BANK LTD'],
  ['AKJB', 'Akola Janata Commercial Cooperative Bank Ltd.', 'AKOLA JANATA COMMERCIAL COOPERATIVE BANK LTD.'],
  ['ALLA', 'Allahabad Bank', 'ALLAHABAD BANK'],
  ['AUCB', 'Almora Urban Cooperative Bank Limited', 'ALMORA URBAN COOPERATIVE BANK LIMITED'],
  ['AJHC', 'Ambarnath Jaihind Coop Bank Ltd Ambarnath', 'AMBARNATH JAIHIND COOP BANK LTD AMBARNATH'],
  ['ANDB', 'Andhra Bank', 'ANDHRA BANK'],
  ['APGV', 'Andhra Pradesh Grameena Vikas Bank', 'ANDHRA PRADESH GRAMEENA VIKAS BANK'],
  ['APGX', 'Andhra Pradesh Grameena Vikas Bank', 'ANDHRA PRADESH GRAMEENA VIKAS BANK'],
  ['APGB', 'Andhra Pragathi Grameena Bank', 'ANDHRA PRAGATHI GRAMEENA BANK'],
  ['ASBL', 'Apna Sahakari Bank Ltd.', 'APNA SAHAKARI BANK LTD.'],
  ['APRX', 'Arunanchal Pradesh Bank', 'Arunanchal Pradesh Bank'],
  ['ARBL', 'Arvind Sahakari Bank Ltd', 'ARVIND SAHAKARI BANK LTD'],
  ['AGVX', 'Assam Gramin Vikash Bank', 'ASSAM GRAMIN VIKASH BANK'],
  ['AUBL', 'AU Small Finance Bank', 'AU SMALL FINANCE BANK LIMITED'],
  ['ANZB', 'Australia and New Zealand Banking Group Limited', 'AUSTRALIA AND NEW ZEALAND BANKING GROUP LIMITED'],
  ['UTIB', 'Axis Bank', 'AXIS BANK'],
  ['BNPA', 'B N P Paribas', 'B N P PARIBAS'],
  ['BDBL', 'Bandhan Bank', 'BANDHAN BANK LIMITED'],
  ['BGVX', 'Bangiya Gramin Vikash Bank', 'BANGIYA GRAMIN VIKASH BANK'],
  ['IBBK', 'Bank International Indonesia', 'BANK INTERNATIONAL INDONESIA'],
  ['BOFA', 'Bank of America', 'BANK OF AMERICA'],
  ['BBKM', 'Bank of Baharain and Kuwait BSC', 'BANK OF BAHARAIN AND KUWAIT BSC'],
  ['BARB', 'Bank of Baroda', 'BANK OF BARODA'],
  ['BCEY', 'Bank of Ceylon', 'BANK OF CEYLON'],
  ['BCHN', 'Bank of China Limited India Branch', 'BANK OF CHINA LIMITED INDIA BRANCH'],
  ['BKID', 'Bank of India', 'BANK OF INDIA'],
  ['MAHB', 'Bank of Maharashtra', 'BANK OF MAHARASHTRA'],
  ['BARA', 'Baramati Sahakari Bank Limited', 'BARAMATI SAHAKARI BANK LIMITED'],
  ['BARC', 'Barclays Bank', 'BARCLAYS BANK'],
  ['BACB', 'Bassein Catholic Cooperative Bank Limited', 'BASSEIN CATHOLIC COOPERATIVE BANK LIMITED'],
  ['BNSB', 'Bhagini Nivedita Sahakari Bank Ltd. Pune', 'BHAGINI NIVEDITA SAHAKARI BANK LTD. PUNE'],
  ['BCBM', 'Bharat Cooperative Bank Mumbai Limited', 'BHARAT COOPERATIVE BANK MUMBAI LIMITED'],
  ['BMBL', 'Bharatiya Mahila Bank Limited', 'BHARATIYA MAHILA BANK LIMITED'],
  ['BMCB', 'Bombay Mercantile Cooperative Bank Ltd', 'BOMBAY MERCANTILE COOPERATIVE BANK LTD'],
  ['CNRB', 'Canara Bank', 'CANARA BANK'],
  ['CLBL', 'Capital Small Finance Bank', 'CAPITAL SMALL FINANCE BANK LIMITED'],
  ['CSBK', 'CSB Bank', 'CATHOLIC SYRIAN BANK LIMITED'],
  ['CBIN', 'Central Bank of India', 'CENTRAL BANK OF INDIA'],
  ['CGBX', 'Chhattisgarh Gramin Bank', 'CHHATTISGARH GRAMIN BANK'],
  ['CRGB', 'Chhattisgarh Rajya Gramin Bank', 'CHHATTISGARH RAJYA GRAMIN BANK'],
  ['CTCB', 'Chinatrust Commercial Bank Limited', 'CHINATRUST COMMERCIAL BANK LIMITED'],
  ['CITI', 'Citibank', 'CITI BANK N A'],
  ['CCBL', 'Citizen Credit Cooperative Bank Limited', 'CITIZEN CREDIT COOPERATIVE BANK LIMITED'],
  ['CIUB', 'City Union Bank', 'CITY UNION BANK LIMITED'],
  ['COAS', 'Coastal Local Area Bank Ltd', 'COASTAL LOCAL AREA BANK LTD'],
  ['CTBA', 'Commonwealth Bank of Australia', 'COMMONWEALTH BANK OF AUSTRALIA'],
  ['CORP', 'Corporation Bank', 'CORPORATION BANK'],
  ['CRLY', 'Credit Agricole Corporate and Investment Bank', 'CREDIT AGRICOLE CORPORATE AND INVESTMENT BANK'],
  ['CRES', 'Credit Suisse AG', 'CREDIT SUISSE AG'],
  ['MBGX', 'Dakshin Bihar Gramin Bank', 'DAKSHIN BIHAR GRAMIN BANK'],
  ['DCUB', 'Darussalam Co Operative Urban Bank Ltd', 'Darussalam Co operative Urban Bank Ltd'],
  ['DBSS', 'DBS Bank India', 'DBS BANK INDIA LIMITED'],
  ['DCBB', 'DCB Bank', 'DCB BANK LIMITED'],
  ['DCBL', 'DCB Bank', 'DCB BANK LIMITED'],
  ['BKDN', 'Dena Bank', 'DENA BANK'],
  ['DEOB', 'Deogiri Nagari Sahakari Bank Ltd. Aurangabad', 'DEOGIRI NAGARI SAHAKARI BANK LTD. AURANGABAD'],
  ['DICG', 'Deposit Insurance and Credit Guarantee Corporation', 'DEPOSIT INSURANCE AND CREDIT GUARANTEE CORPORATION'],
  ['DEUT', 'Deutsche Bank', 'DEUTSCHE BANK'],
  ['DBOS', 'Development Bank of Singapore', 'DEVELOPMENT BANK OF SINGAPORE'],
  ['DLXB', 'Dhanlaxmi Bank', 'DHANLAXMI BANK LIMITED'],
  ['DMKJ', 'DMK Jaoli Bank', 'DMK JAOLI BANK'],
  ['DOHB', 'Doha Bank', 'DOHA BANK'],
  ['DOHA', 'Doha Bank QSC', 'DOHA BANK QSC'],
  ['DNSB', 'Dombivli Nagari Sahakari Bank Limited', 'DOMBIVLI NAGARI SAHAKARI BANK LIMITED'],
  ['DURG', 'Durgapur Steel Peoples Co-operative Bank Ltd', 'DURGAPUR STEEL PEOPLES CO-OPERATIVE BANK LTD'],
  ['EDBX', 'Ellaquai Dehati Bank', 'Ellaquai Dehati Bank'],
  ['EBIL', 'Emirates NBD Bank P J S C', 'EMIRATES NBD BANK P J S C'],
  ['ESFB', 'Equitas Small Finance Bank', 'EQUITAS SMALL FINANCE BANK LIMITED'],
  ['ESMF', 'ESAF Small Finance Bank', 'ESAF SMALL FINANCE BANK LIMITED'],
  ['EIBI', 'Exim Bank', 'EXPORT IMPORT BANK OF INDIA'],
  ['EXIB', 'Exim Bank', 'EXPORT IMPORT BANK OF INDIA'],
  ['FDRL', 'Federal Bank', 'FEDERAL BANK'],
  ['FSFB', 'Fincare Small Finance Bank', 'FINCARE SMALL FINANCE BANK LTD'],
  ['FINO', 'Fino Payments Bank', 'FINO PAYMENTS BANK LIMITED'],
  ['FIRN', 'Firstrand Bank Limited', 'FIRSTRAND BANK LIMITED'],
  ['PJSB', 'G P Parsik Bank', 'G P PARSIK BANK'],
  ['GSSB', 'Guardian Souharda Sahakari Bank Niyamita', 'GUARDIAN SOUHARDA SAHAKARI BANK NIYAMITA'],
  ['GGBK', 'Gurgaon Gramin Bank', 'GURGAON GRAMIN BANK'],
  ['HARC', 'Haryana State Cooperative Bank', 'HARYANA STATE COOPERATIVE BANK'],
  ['HDFC', 'HDFC Bank', 'HDFC BANK'],
  ['HMBX', 'Himachal Gramin Bank', 'HIMACHAL GRAMIN BANK'],
  ['HPSC', 'Himachal Pradesh State Cooperative Bank Ltd', 'HIMACHAL PRADESH STATE COOPERATIVE BANK LTD'],
  ['HSBC', 'HSBC', 'HSBC BANK'],
  ['HUSB', 'Hutatma Sahakari Bank Ltd', 'Hutatma Sahakari Bank Ltd'],
  ['ICIC', 'ICICI Bank', 'ICICI BANK LIMITED'],
  ['IBKL', 'IDBI Bank', 'IDBI BANK'],
  ['IDFB', 'IDFC First Bank', 'IDFC FIRST BANK LIMITED'],
  ['IDUK', 'Idukki District Co Operative Bank Ltd', 'IDUKKI DISTRICT CO OPERATIVE BANK LTD'],
  ['IPOS', 'India Post Payments Bank', 'INDIA POST PAYMENTS BANK LIMITED'],
  ['IDIB', 'Indian Bank', 'INDIAN BANK'],
  ['IOBA', 'Indian Overseas Bank', 'INDIAN OVERSEAS BANK'],
  ['INDB', 'IndusInd Bank', 'INDUSIND BANK'],
  ['ICBK', 'Industrial and Commercial Bank of China Limited', 'INDUSTRIAL AND COMMERCIAL BANK OF CHINA LIMITED'],
  ['IBKO', 'Industrial Bank of Korea', 'INDUSTRIAL BANK OF KOREA'],
  ['VYSA', 'ING Vysya Bank', 'ING VYSYA BANK'],
  ['ITBL', 'Irinjalakuda Town Co-operative Bank Ltd.', 'IRINJALAKUDA TOWN CO-OPERATIVE BANK LTD.'],
  ['JJSB', 'Jalgaon Janata Sahakari Bank Limited', 'JALGAON JANATA SAHAKARI BANK LIMITED'],
  ['JAKA', 'J&K Bank', 'JAMMU AND KASHMIR BANK LIMITED'],
  ['JSFB', 'Jana Small Finance Bank', 'JANA SMALL FINANCE BANK LTD.'],
  ['JSBL', 'Janakalyan Sahakari Bank Limited', 'JANAKALYAN SAHAKARI BANK LIMITED'],
  ['JASB', 'Janaseva Sahakari Bank Borivli Limited', 'JANASEVA SAHAKARI BANK BORIVLI LIMITED'],
  ['JANA', 'Janaseva Sahakari Bank Limited', 'JANASEVA SAHAKARI BANK LIMITED'],
  ['JSBP', 'Janata Sahakari Bank Limited', 'JANATA SAHAKARI BANK LIMITED'],
  ['JTSC', 'Janatha Seva Cooperative Bank Ltd', 'JANATHA SEVA COOPERATIVE BANK LTD'],
  ['VGBX', 'Jharkhand Rajya Gramin Bank', 'JHARKHAND RAJYA GRAMIN BANK'],
  ['JIOP', 'Jio Payments Bank', 'JIO PAYMENTS BANK LIMITED'],
  ['CHAS', 'Jp Morgan Bank', 'JP MORGAN BANK'],
  ['VTBJ', 'JSC VTB Bank', 'JSC VTB BANK'],
  [
    'KAIJ',
    'Kallappanna Awade Ichalkaranji Janata Sahakari Bank Limited',
    'KALLAPPANNA AWADE ICHALKARANJI JANATA SAHAKARI BANK LIMITED',
  ],
  ['KCCB', 'Kalupur Commercial Co-op Bank', 'KALUPUR COMMERCIAL CO-OP BANK'],
  ['KJSB', 'Kalyan Janata Sahakari Bank', 'KALYAN JANATA SAHAKARI BANK'],
  ['KCBL', 'Kapol Cooperative Bank Limited', 'KAPOL COOPERATIVE BANK LIMITED'],
  ['KARB', 'Karnataka Bank', 'KARNATAKA BANK LIMITED'],
  ['PGBX', 'Karnataka Gramin Bank', 'KARNATAKA GRAMIN BANK'],
  ['KVGB', 'Karnataka Vikas Grameena Bank', 'KARNATAKA VIKAS GRAMEENA BANK'],
  ['KVBL', 'Karur Vysya Bank', 'KARUR VYSYA BANK'],
  ['KGRB', 'Kaveri Grameena Bank', 'KAVERI GRAMEENA BANK'],
  ['KOEX', 'KEB Hana Bank', 'KEB HANA BANK'],
  ['KLGB', 'Kerala Gramin Bank', 'KERALA GRAMIN BANK'],
  ['KBKB', 'Kookmin Bank', 'KOOKMIN BANK'],
  ['KKBK', 'Kotak Mahindra Bank', 'KOTAK MAHINDRA BANK LIMITED'],
  ['KDCB', 'Kozhikode District Co-operative Bank Limited', 'KOZHIKODE DISTRICT CO-OPERATIVE BANK LIMITED'],
  ['KRTH', 'Krung Thai Bank PCL', 'KRUNG THAI BANK PCL'],
  ['LAVB', 'Lakshmi Vilas Bank', 'LAXMI VILAS BANK LTD.'],
  ['MADX', 'Madhyanchal Gramin Bank', 'MADHYANCHAL GRAMIN BANK'],
  ['MCBL', 'Mahanagar Cooperative Bank', 'MAHANAGAR COOPERATIVE BANK'],
  ['MAHG', 'Maharashtra Gramin Bank', 'Maharashtra Gramin Bank'],
  ['MSCI', 'Maharashtra State Cooperative Bank', 'MAHARASHTRA STATE COOPERATIVE BANK'],
  ['MSBL', 'Mahesh Sahakari Bank Ltd Pune', 'Mahesh Sahakari Bank Ltd Pune'],
  ['MRBX', 'Manipur Rural Bank', 'MANIPUR RURAL BANK'],
  ['MSHQ', 'Mashreqbank PSC', 'MASHREQBANK PSC'],
  ['MERX', 'Meghalaya Rural Bank', 'MEGHALAYA RURAL BANK'],
  ['MZRX', 'Mizoram Rural Bank', 'Mizoram Rural Bank'],
  ['MHCB', 'Mizuho Bank Ltd', 'MIZUHO BANK LTD'],
  ['MDBK', 'Model Cooperative Bank Ltd', 'MODEL COOPERATIVE BANK LTD'],
  ['BOTM', 'MUFG Bank, Ltd', 'MUFG BANK, LTD'],
  ['NAGX', 'Nagaland Rural Bank', 'Nagaland Rural Bank'],
  ['NUCB', 'Nagar Urban Co Operative Bank', 'NAGAR URBAN CO OPERATIVE BANK'],
  ['NGSB', 'Nagpur Nagarik Sahakari Bank Limited', 'NAGPUR NAGARIK SAHAKARI BANK LIMITED'],
  ['NATA', 'National Australia Bank Limited', 'NATIONAL AUSTRALIA BANK LIMITED'],
  ['NBRD', 'NABARD', 'NATIONAL BANK FOR AGRICULTURE AND RURAL DEVELOPMENT'],
  ['NBAD', 'National Bank of Abu Dhabi PJSC', 'NATIONAL BANK OF ABU DHABI PJSC'],
  ['NJBK', 'Nav Jeevan Co Op Bank Ltd', 'NAV JEEVAN CO OP BANK LTD'],
  ['NICB', 'New India Cooperative Bank Limited', 'NEW INDIA COOPERATIVE BANK LIMITED'],
  ['NKGS', 'NKGSB Co-operative Bank', 'NKGSB COOPERATIVE BANK LIMITED'],
  ['NHBA', 'Nonghyup Bank', 'NONGHYUP BANK'],
  ['NESF', 'North East Small Finance Bank', 'NORTH EAST SMALL FINANCE BANK LIMITED'],
  ['NSPB', 'NSDL Payments Bank', 'NSDL PAYMENTS BANK LIMITED'],
  ['NNSB', 'Nutan Nagarik Sahakari Bank Limited', 'NUTAN NAGARIK SAHAKARI BANK LIMITED'],
  ['ORBC', 'Oriental Bank of Commerce', 'ORIENTAL BANK OF COMMERCE'],
  ['ORCB', 'Orissa State Cooperative Bank Bank Ltd', 'ORISSA STATE COOPERATIVE BANK BANK LTD'],
  ['PSBL', 'Pavana Sahakari Bank Ltd', 'Pavana Sahakari Bank LTD'],
  ['PPNT', 'Pay Point India Network Private Limited', 'PAY POINT INDIA NETWORK PRIVATE LIMITED'],
  ['PYTM', 'Paytm Payments Bank', 'PAYTM PAYMENTS BANK LIMITED'],
  ['PHNP', 'PhonePe', 'PHONEPE PRIVATE LIMITED'],
  ['PKGB', 'Pragathi Krishna Gramin Bank', 'PRAGATHI KRISHNA GRAMIN BANK'],
  ['PRTH', 'Prathama Bank', 'PRATHAMA BANK'],
  ['SUBX', 'Prathama Up Gramin Bank', 'PRATHAMA UP GRAMIN BANK'],
  ['PMEC', 'Prime Cooperative Bank Limited', 'PRIME COOPERATIVE BANK LIMITED'],
  ['PTBI', 'PT Bank Maybank Indonesia TBK', 'PT BANK MAYBANK INDONESIA TBK'],
  ['PMCB', 'Punjab and Maharshtra Cooperative Bank', 'PUNJAB AND MAHARSHTRA COOPERATIVE BANK'],
  ['PSIB', 'Punjab & Sind Bank', 'PUNJAB AND SIND BANK'],
  ['PUGX', 'Punjab Gramin Bank', 'PUNJAB GRAMIN BANK'],
  ['PUNB', 'Punjab National Bank', 'PUNJAB NATIONAL BANK'],
  ['QNBA', 'Qatar National Bank SAQ', 'QATAR NATIONAL BANK SAQ'],
  ['RABO', 'Rabobank International', 'RABOBANK INTERNATIONAL'],
  ['RRBP', 'Rajarambapu Sahakari Bank Limited', 'RAJARAMBAPU SAHAKARI BANK LIMITED'],
  ['RSSB', 'Rajarshi Shahu Sahakari Bank Ltd Pune', 'RAJARSHI SHAHU SAHAKARI BANK LTD  PUNE'],
  ['MDGX', 'Rajasthan Marudhara Gramin Bank', 'RAJASTHAN MARUDHARA GRAMIN BANK'],
  ['RMGB', 'Rajasthan Marudhara Gramin Bank', 'RAJASTHAN MARUDHARA GRAMIN BANK'],
  ['RSBL', 'Rajgurunagar Sahakari Bank Limited', 'RAJGURUNAGAR SAHAKARI BANK LIMITED'],
  ['RNSB', 'Rajkot Nagrik Sahakari Bank Limited', 'RAJKOT NAGRIK SAHAKARI BANK LIMITED'],
  ['RDCB', 'Rajnandgaon District Central Co-operative Bank Ltd', 'Rajnandgaon District Central Co-operative Bank Ltd'],
  ['RATN', 'RBL Bank', 'RBL BANK LIMITED'],
  ['RBLB', 'RBL Bank', 'RBL Bank Limited'],
  ['RBIN', 'Reserve Bank of India', 'RESERVE BANK OF INDIA'],
  ['RBIP', 'Reserve Bank of India', 'RESERVE BANK OF INDIA'],
  ['RBIS', 'Reserve Bank of India, Pad', 'RESERVE BANK OF INDIA, PAD'],
  ['SAHE', 'Sahebrao Deshmukh Cooperative Bank Limited', 'SAHEBRAO DESHMUKH COOPERATIVE BANK LIMITED'],
  ['SBLS', 'Samarth Sahakari Bank Ltd', 'SAMARTH SAHAKARI BANK LTD'],
  ['SANT', 'Sant Sopankaka Sahakari Bank Ltd.', 'SANT SOPANKAKA SAHAKARI BANK LTD.'],
  ['SAGB', 'Saptagiri Grameena Bank', 'SAPTAGIRI GRAMEENA BANK'],
  ['SNBK', 'Saraspur Nagrik Cooperative Bank Ltd Saraspur.', 'Saraspur Nagrik Cooperative Bank Ltd Saraspur.'],
  ['SRCB', 'Saraswat Bank', 'SARASWAT CO-OPERATIVE BANK LTD.'],
  ['HGBX', 'Sarva Haryana Gramin Bank', 'SARVA HARYANA GRAMIN BANK'],
  ['SDCE', 'Satara District Central Co Op Bank Ltd', 'SATARA DISTRICT CENTRAL CO OP BANK LTD'],
  ['TSSB', 'Satara Sahakari Bank Ltd', 'Satara Sahakari Bank Ltd'],
  ['SAGX', 'Saurashtra Gramin Bank', 'SAURASHTRA GRAMIN BANK'],
  ['SGBA', 'Saurashtra Gramin Bank', 'Saurashtra Gramin Bank'],
  ['SABR', 'SBER Bank', 'SBER BANK'],
  ['SBMB', 'SBM Bank Mauritius Limited', 'SBM BANK MAURITIUS LIMITED'],
  ['SKSB', 'Shikshak Sahakari Bank Limited', 'SHIKSHAK SAHAKARI BANK LIMITED'],
  ['SHBK', 'Shinhan Bank', 'SHINHAN BANK'],
  ['SMCB', 'Shivalik Mercantile Co Operative Bank Ltd', 'SHIVALIK MERCANTILE CO OPERATIVE BANK LTD'],
  ['SKNB', 'Shree Kadi Nagarik Sahakari Bank Limited', 'Shree Kadi Nagarik Sahakari Bank Limited'],
  [
    'CRUB',
    'Shri Chhatrapati Rajashri Shahu Urban Cooperative Bank Limited',
    'SHRI CHHATRAPATI RAJASHRI SHAHU URBAN COOPERATIVE BANK LIMITED',
  ],
  ['SVSH', 'Shri Veershaiv Co-op. Bank Ltd.', 'SHRI VEERSHAIV CO-OP. BANK LTD.'],
  ['MVCB', 'Sir M Visvesvaraya Co-operative Bank Ltd.', 'SIR M VISVESVARAYA CO-OPERATIVE BANK LTD.'],
  ['SIDB', 'SIDBI', 'SMALL INDUSTRIES DEVELOPMENT BANK OF INDIA'],
  ['SMNB', 'Smriti Nagrik Sahakari Bank Maryadit', 'Smriti Nagrik Sahakari Bank Maryadit'],
  ['SOGE', 'Societe Generale', 'SOCIETE GENERALE'],
  ['SJSB', 'Solapur Janata Sahakari Bank Limited', 'SOLAPUR JANATA SAHAKARI BANK LIMITED'],
  ['SIBL', 'South Indian Bank', 'SOUTH INDIAN BANK'],
  ['SECB', 'Sree Charan Souhardha Cooperative Bank Ltd', 'SREE CHARAN SOUHARDHA COOPERATIVE BANK LTD'],
  ['SCBL', 'Standard Chartered', 'STANDARD CHARTERED BANK'],
  ['SBIN', 'State Bank of India', 'STATE BANK OF INDIA'],
  ['STCB', 'State Bank of Mauritius', 'STATE BANK OF MAURITIUS'],
  ['SUSB', 'Suco Souharda Sahakari Bank Ltd', 'Suco Souharda Sahakari Bank Ltd'],
  ['SMBC', 'Sumitomo Mitsui Banking Corporation', 'SUMITOMO MITSUI BANKING CORPORATION'],
  ['SUNB', 'Surat National Cooperative Bank Limited', 'SURAT NATIONAL COOPERATIVE BANK LIMITED'],
  ['SURY', 'Suryoday Small Finance Bank', 'SURYODAY SMALL FINANCE BANK LIMITED'],
  ['SUTB', 'Sutex Cooperative Bank Limited', 'SUTEX COOPERATIVE BANK LIMITED'],
  ['SYNB', 'Syndicate Bank', 'SYNDICATE BANK'],
  ['TMBL', 'Tamilnad Mercantile Bank', 'TAMILNAD MERCANTILE BANK LTD'],
  ['DGBX', 'Telangana Grameena Bank', 'TELANGANA GRAMEENA BANK'],
  ['TGRB', 'Telangana Grameena Bank', 'TELANGANA GRAMEENA BANK'],
  ['TSAB', 'Telangana State Coop Apex Bank', 'TELANGANA STATE COOP APEX BANK'],
  ['TTCB', 'Textile Traders Co-operative Bank Limited', 'TEXTILE TRADERS CO-OPERATIVE BANK LIMITED'],
  ['APMC', 'The A.P. Mahesh Cooperative Urban Bank Limited', 'THE A.P. MAHESH COOPERATIVE URBAN BANK LIMITED'],
  ['ADBK', 'The Adarsh Cooperative Urban Bank Limited', 'THE ADARSH COOPERATIVE URBAN BANK LIMITED'],
  [
    'AHDC',
    'The Ahmednagar District Central Co-operative Bank Ltd',
    'THE AHMEDNAGAR DISTRICT CENTRAL CO-OPERATIVE BANK LTD',
  ],
  ['AJAR', 'The Ajara Urban Co Op Bank Ltd Ajara', 'The Ajara Urban Co op Bank Ltd Ajara'],
  ['ADCC', 'The Akola District Central Cooperative Bank', 'THE AKOLA DISTRICT CENTRAL COOPERATIVE BANK'],
  ['TAUB', 'The Akola Urban Cooperative Bank Limited', 'The Akola Urban Cooperative Bank Limited'],
  ['APBL', 'The Andhra Pradesh State Cooperative Bank Limited', 'THE ANDHRA PRADESH STATE COOPERATIVE BANK LIMITED'],
  ['TBMC', 'The Banaskantha Mercantile Cooperative Bank Ltd', 'The Banaskantha Mercantile Cooperative Bank Ltd'],
  ['NOSC', 'The Bank of Nova Scotia', 'THE BANK OF NOVA SCOTIA'],
  ['BUCB', 'The Burdwan Central Co Operative Bank Ltd', 'THE BURDWAN CENTRAL CO OPERATIVE BANK LTD'],
  ['CCIL', 'The Clearing Corporation of India Limited', 'THE CLEARING CORPORATION OF INDIA LIMITED'],
  ['TCBR', 'The Cooperative Bank of Rajkot Limited', 'THE COOPERATIVE BANK OF RAJKOT LIMITED'],
  ['COSB', 'Cosmos Bank', 'THE COSMOS CO OPERATIVE BANK LIMITED'],
  ['DLSC', 'The Delhi State Cooperative Bank Limited', 'THE DELHI STATE COOPERATIVE BANK LIMITED'],
  [
    'GDCB',
    'The Gadchiroli District Central Cooperative Bank Limited',
    'THE GADCHIROLI DISTRICT CENTRAL COOPERATIVE BANK LIMITED',
  ],
  ['GABK', 'The Gayatri Co-operative Urban Bank Limited', 'THE GAYATRI CO-OPERATIVE URBAN BANK LIMITED'],
  ['GBCB', 'The Greater Bombay Cooperative Bank Limited', 'THE GREATER BOMBAY COOPERATIVE BANK LIMITED'],
  ['GSCB', 'The Gujarat State Cooperative Bank Limited', 'THE GUJARAT STATE COOPERATIVE BANK LIMITED'],
  ['HCBL', 'The Hasti Coop Bank Ltd', 'THE HASTI COOP BANK LTD'],
  ['JPCB', 'The Jalgaon Peopels Cooperative Bank Limited', 'THE JALGAON PEOPELS COOPERATIVE BANK LIMITED'],
  ['KACE', 'The Kangra Central Cooperative Bank Limited', 'THE KANGRA CENTRAL COOPERATIVE BANK LIMITED'],
  ['KANG', 'The Kangra Cooperative Bank Limited', 'THE KANGRA COOPERATIVE BANK LIMITED'],
  ['KUCB', 'The Karad Urban Cooperative Bank Limited', 'THE KARAD URBAN COOPERATIVE BANK LIMITED'],
  ['KSCB', 'The Karanataka State Cooperative Apex Bank Limited', 'THE KARANATAKA STATE COOPERATIVE APEX BANK LIMITED'],
  ['KSBK', 'The Kerala State Co Operative Bank Ltd', 'The Kerala State Co Operative Bank Ltd'],
  ['KOLH', 'The Kolhapur Urban Co-op. Bank Ltd.', 'THE KOLHAPUR URBAN CO-OP. BANK LTD.'],
  ['KNBL', 'The Kurla Nagarik Sahakari Bank Ltd', 'THE KURLA NAGARIK SAHAKARI BANK LTD'],
  ['KNSB', 'The Kurmanchal Nagar Sahakari Bank Limited', 'THE KURMANCHAL NAGAR SAHAKARI BANK LIMITED'],
  ['LUCB', 'The Latur Urban Cooperative Bank Ltd', 'THE LATUR URBAN COOPERATIVE BANK LTD'],
  ['TMSB', 'The Malad Sahakari Bank Ltd', 'The Malad Sahakari Bank Ltd'],
  ['MKPB', 'The Malkapur Urban Co Operative Bank Ltd Malkapur', 'The Malkapur Urban Co Operative Bank Ltd Malkapur'],
  ['MCAB', 'The Meghalaya Cooperative Apex Bank Ltd', 'THE MEGHALAYA COOPERATIVE APEX BANK LTD'],
  ['MSNU', 'The Mehsana Urban Cooperative Bank', 'THE MEHSANA URBAN COOPERATIVE BANK'],
  [
    'MDCB',
    'The Mumbai District Central Cooperative Bank Limited',
    'THE MUMBAI DISTRICT CENTRAL COOPERATIVE BANK LIMITED',
  ],
  ['MUBL', 'The Municipal Cooperative Bank Limited', 'THE MUNICIPAL COOPERATIVE BANK LIMITED'],
  ['MSLM', 'The Muslim Co-operative Bank Ltd.', 'THE MUSLIM CO-OPERATIVE BANK LTD.'],
  ['NTBL', 'Nainital Bank', 'THE NAINITAL BANK LIMITED'],
  ['NMCB', 'The Nasik Merchants Cooperative Bank Limited', 'THE NASIK MERCHANTS COOPERATIVE BANK LIMITED'],
  ['NDVS', 'The Nasik Road Deolali Vyapari Sahakari Bank Ltd', 'THE NASIK ROAD DEOLALI VYAPARI SAHAKARI BANK LTD'],
  ['NVNM', 'The Navnirman Co-operative Bank Limited', 'THE NAVNIRMAN CO-OPERATIVE BANK LIMITED'],
  ['TNCB', 'The Nawanagar Cooperative Bank Ltd', 'THE NAWANAGAR COOPERATIVE BANK LTD'],
  ['NCUB', 'The Nilambur Co Operative Urban Bank Ltd Nilambur', 'THE NILAMBUR CO OPERATIVE URBAN BANK LTD NILAMBUR'],
  ['PUCB', 'The Pandharpur Urban Co Op. Bank Ltd. Pandharpur', 'THE PANDHARPUR URBAN CO OP. BANK LTD. PANDHARPUR'],
  ['TPSC', 'The Punjab State Cooperative Bank Ltd', 'THE PUNJAB STATE COOPERATIVE BANK LTD'],
  ['PUSD', 'The Pusad Urban Cooperative Bank Ltd Pusad', 'The Pusad Urban Cooperative Bank Ltd Pusad'],
  ['RSCB', 'The Rajasthan State Cooperative Bank Limited', 'THE RAJASTHAN STATE COOPERATIVE BANK LIMITED'],
  ['ABNA', 'The Royal Bank of Scotland N V', 'THE ROYAL BANK OF SCOTLAND N V'],
  ['SVBL', 'The Seva Vikas Cooperative Bank Limited', 'THE SEVA VIKAS COOPERATIVE BANK LIMITED'],
  ['SVCB', 'SVC Co-operative Bank', 'THE SHAMRAO VITHAL COOPERATIVE BANK'],
  [
    'SIDC',
    'The Sindhudurg District Central Co-operative Bank Limited',
    'THE SINDHUDURG DISTRICT CENTRAL CO-OPERATIVE BANK LIMITED',
  ],
  ['SDCB', 'The Surat District Cooperative Bank Limited', 'THE SURAT DISTRICT COOPERATIVE BANK LIMITED'],
  ['SPCB', 'The Surath Peoples Cooperative Bank Limited', 'THE SURATH PEOPLES COOPERATIVE BANK LIMITED'],
  ['TNSC', 'The Tamil Nadu State Apex Cooperative Bank', 'THE TAMIL NADU STATE APEX COOPERATIVE BANK'],
  ['TBSB', 'The Thane Bharat Sahakari Bank Limited', 'THE THANE BHARAT SAHAKARI BANK LIMITED'],
  [
    'TDCB',
    'The Thane District Central Cooperative Bank Limited',
    'THE THANE DISTRICT CENTRAL COOPERATIVE BANK LIMITED',
  ],
  ['UUCB', 'The Udaipur Urban Co Operative Bank Ltd', 'THE UDAIPUR URBAN CO OPERATIVE BANK LTD'],
  [
    'URBN',
    'The Urban Co-operative Bank Ltd. no. One Seven Five Eight Perinthalmanna',
    'THE URBAN CO-OPERATIVE BANK LTD. NO. ONE SEVEN FIVE EIGHT PERINTHALMANNA',
  ],
  ['VARA', 'The Varachha Cooperative Bank Limited', 'THE VARACHHA COOPERATIVE BANK LIMITED'],
  ['VCOB', 'The Vijay Co Operative Bank Limited.', 'The Vijay Co Operative Bank Limited.'],
  ['VSBL', 'The Vishweshwar Sahakari Bank Limited', 'THE VISHWESHWAR SAHAKARI BANK LIMITED'],
  ['WBSC', 'The West Bengal State Cooperative Bank', 'THE WEST BENGAL STATE COOPERATIVE BANK'],
  ['ZCBL', 'The Zoroastrian Cooperative Bank Limited', 'THE ZOROASTRIAN COOPERATIVE BANK LIMITED'],
  ['THRS', 'Thrissur District Co-operative Bank Limited', 'THRISSUR DISTRICT CO-OPERATIVE BANK LIMITED'],
  ['TJSB', 'TJSB Sahakari Bank', 'TJSB SAHAKARI BANK LTD'],
  ['TGBX', 'Tripura Gramin Bank', 'TRIPURA GRAMIN BANK'],
  ['TGMB', 'Tumkur Grain Merchants Cooperative Bank Limited', 'TUMKUR GRAIN MERCHANTS COOPERATIVE BANK LIMITED'],
  ['UCBA', 'UCO Bank', 'UCO BANK'],
  ['UJVN', 'Ujjivan Small Finance Bank', 'UJJIVAN SMALL FINANCE BANK LIMITED'],
  ['USFB', 'Ujjivan Small Finance Bank', 'UJJIVAN SMALL FINANCE BANK LTD'],
  ['UBIN', 'Union Bank of India', 'UNION BANK OF INDIA'],
  ['UTBI', 'United Bank of India', 'UNITED BANK OF INDIA'],
  ['UOVB', 'United Overseas Bank Limited', 'UNITED OVERSEAS BANK LIMITED'],
  ['UNBA', 'Unity Small Finance Bank', 'Unity Small finance Bank Limited'],
  ['UCLB', 'Urban Co Operative Bank Ltd Bareilly', 'URBAN CO OPERATIVE BANK LTD BAREILLY'],
  ['UGBX', 'Utkal Grameen Bank', 'UTKAL GRAMEEN BANK'],
  ['UTKS', 'Utkarsh Small Finance Bank', 'UTKARSH SMALL FINANCE BANK'],
  ['UPCB', 'Uttar Pradesh Cooperative Bank Ltd', 'UTTAR PRADESH COOPERATIVE BANK LTD'],
  ['UTGX', 'Uttarakhand Gramin Bank', 'UTTARAKHAND GRAMIN BANK'],
  ['USCB', 'Uttarakhand State Cooperative Bank Limited', 'UTTARAKHAND STATE COOPERATIVE BANK LIMITED'],
  ['VASJ', 'Vasai Janata Sahakari Bank Ltd.', 'VASAI JANATA SAHAKARI BANK LTD.'],
  ['VVSB', 'Vasai Vikas Sahakari Bank Ltd', 'VASAI VIKAS SAHAKARI BANK LTD'],
  ['VIJB', 'Vijaya Bank', 'VIJAYA BANK'],
  ['VSBA', 'Vikas Souharda Co Operative Bank Limited', 'VIKAS SOUHARDA CO OPERATIVE BANK LIMITED'],
  ['WPAC', 'Westpac Banking Corporation', 'WESTPAC BANKING CORPORATION'],
  ['HVBK', 'Woori Bank', 'WOORI BANK'],
  ['YESB', 'Yes Bank', 'YES BANK'],
  ['ZSBL', 'Zila Sahakri Bank Limited Ghaziabad', 'ZILA SAHAKRI BANK LIMITED GHAZIABAD'],
];
